<template>
  <v-container fluid class="px-0 py-0">
    <CommonDetail
        :uid-item="uidItem"
        :store-name="storeName"
        :dto-detail-query="dtoDetailQuery"
        :dto-save-command="dtoSaveCommand"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :main-validator="mainValidator"
        :modal-dialog="modalDialog"
        :parent-component="parentComponent"
        :wrap-component="$options.name"
        @close="$emit('close')"
        @embedded_action="embeddedAction($event)"
    >
      <template v-slot:body="{height}">
        <v-sheet class="pt-3 px-3" v-if="!!currentItem">
          <v-row dense>
            <v-col cols="3">
              <CommonFieldString
                  v-model="currentItem.name"
                  :label="$t('name')"
              ></CommonFieldString>
            </v-col>
            <v-col cols="2">
              <CommonFieldString
                  v-model="currentItem.article_number"
                  :label="$t('article_number')"
                  outlined
                  readonly
                  class="mr-3"
                  :append-icon="!!currentItem.article_number ? '' : 'mdi-alert-outline'"
              >
              </CommonFieldString>
            </v-col>
            <v-col cols="2">
              <CommonFieldString
                  v-model="customer_name"
                  :label="$t('customer')"
                  outlined
                  readonly
                  class="mr-3"
                  :append-icon="!!customer_name ? '' : 'mdi-alert-outline'"
              >
              </CommonFieldString>
            </v-col>
            <v-col cols="5" class="my-1 py-0">
                        <CommonSelectFromTable
                            store-name="CustomerOrder"
                            label="Customer order"
                            v-model="currentItem.customer_order_uid"
                            dto-list-query="CustomerOrderListQueryDTO"
                            :sort-by="['name']"
                            :error-empty="true"
                        >
                        </CommonSelectFromTable>
            </v-col>
          </v-row>
          <v-tabs class="mt-n6" v-if="!!currentItem">
            <v-tab>Import&Match</v-tab>
            <v-tab-item>
              <CoreBomMatchTable :product_order_uid="storeUidItem" :height="height"></CoreBomMatchTable>
            </v-tab-item>
            <v-tab>MainAttributes</v-tab>
            <v-tab-item>
              <CoreBomMainAttrTable :product_order_uid="storeUidItem" :height="height"></CoreBomMainAttrTable>
            </v-tab-item>
            <v-tab>Panasonic</v-tab>
            <v-tab-item>
              <CoreBomPanasonicTable :product_order_uid="storeUidItem" :height="height"></CoreBomPanasonicTable>
            </v-tab-item>
            <v-tab>Pick & Place</v-tab>
            <v-tab-item>
              <CoreProductOrderPickPlaceTable :product_order_uid="storeUidItem" :height="height"></CoreProductOrderPickPlaceTable>
            </v-tab-item>
          </v-tabs>
        </v-sheet>
      </template>
    </CommonDetail>
    <v-dialog
        v-model="dialogImportTable"
    >
      <CoreBomImportTable
          @cancel="onImportClose()"
          @import="importTable($event)"
      >
      </CoreBomImportTable>
    </v-dialog>
    <v-dialog
        v-model="dialogImportPickPlaceTable"
    >
      <CoreImportPickPlaceTable
          @cancel="onImportPickPlaceClose()"
          @import="importPickPlaceTable($event)"
      >
      </CoreImportPickPlaceTable>
    </v-dialog>
  </v-container>
</template>

<script>
import {v4 as uuidv4} from "uuid";
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useDetailStore} from "@/components/Common/CommonDetail";
import CommonDetail from "@/components/Common/CommonDetail";
import BaseFieldString from "@/components/Base/BaseFieldString";
import CommonFieldString from "@/components/Common/CommonFieldString";
import CommonFieldNumber from "@/components/Common/CommonFieldNumber";
import CoreBomSheetTable from "@/components/CoreComponent/BomSheet/CoreBomSheetTable";
import {useTableStore} from "@/components/Common/CommonTable";
import CoreBomImportTable from "@/components/CoreComponent/Bom/CoreBomImportTable";
import CorePickPlaceSheetTable from "@/components/CoreComponent/PickPlaceSheet/CorePickPlaceSheetTable";
import CoreImportPickPlaceTable from "@/components/CoreComponent/PickPlace/CoreImportPickPlaceTable";
import CommonPartialSelectFromTable from "@/components/Common/CommonPartialSelectFromTable";
import CoreBomMatchTable from "@/components/CoreComponent/ProductOrder/CoreBomMatchTable";
import CoreBomMainAttrTable from "@/components/CoreComponent/ProductOrder/CoreBomMainAttrTable";
import CoreBomPanasonicTable from "@/components/CoreComponent/ProductOrder/CoreBomPanasonicTable";
import CoreProductOrderPickPlaceTable from "@/components/CoreComponent/ProductOrder/CoreProductOrderPickPlaceTable";
import CommonSelectFromTable from "@/components/Common/CommonSelectFromTable.vue";

export default {
  name: "CoreProductOrderDetail",

  props: {
    uidItem: {default: null},
    storeName: {type: [String], default: 'ProductOrderDetail'},
    dtoDetailQuery: {default: 'ProductOrderDetailQueryDTO'},
    dtoActionCommand: {type: [String], default: 'ProductOrderActionCommandDTO'},
    dtoSaveCommand: {type: [String], default: 'ProductOrderSaveCommandDTO'},
    dtoValidateCommand: {type: [String], default: 'ProductOrderValidateCommandDTO'},
    dtoModelForValidate: {type: [String], default: 'ProductOrderDTO'},
    mainValidator: {type: [Boolean], default: true},
    modalDialog: {type: [Boolean], default: false},
    parentComponent: {type: [String], default: 'ProductOrderTable'},
    routeFullScreen: {type: [Object], default: null},
  },

  components: {
    CommonSelectFromTable,
    CoreBomSheetTable,
    BaseFieldString,
    CommonDetail,
    CommonFieldString,
    CommonFieldNumber,
    CoreBomImportTable,
    CorePickPlaceSheetTable,
    CoreImportPickPlaceTable,
    CommonPartialSelectFromTable,
    CoreBomMatchTable,
    CoreBomMainAttrTable,
    CoreBomPanasonicTable,
    CoreProductOrderPickPlaceTable,
  },

  computed: {
    currentItem() {
      if (!!this.storeAggregate && !!this.storeAggregate.rootData && !!this.storeDetail && !!this.storeDetail.uidItem)
        return this.storeAggregate.rootData[this.storeDetail.uidItem]
      else
        return null
    },
    storeUidItem() {
      if (!!this.storeDetail)
        return this.storeDetail.uidItem
      else
        return null
    },
    product_uid() {
      if (!!this.currentItem && !!this.currentItem.uid)
        return this.currentItem.uid
      return null
    },
    product_article_number() {
      if (!!this.product_uid)
        return this.storeAggregate.rootData[this.product_uid].article_number
      else
        return null
    },
    customer_uid() {
      if (!!this.product_uid &&
          !!this.storeAggregate.rootData[this.product_uid] &&
          !!this.storeAggregate.rootData[this.storeAggregate.rootData[this.product_uid].customer_order_uid])
        return this.storeAggregate.rootData[this.storeAggregate.rootData[this.product_uid].customer_order_uid].customer_uid
      return null
    },
    customer_name() {
      if (!!this.customer_uid)
        return this.storeAggregate.rootData[this.customer_uid].name
      else
        return null
    },
  },

  methods: {
    embeddedAction(event) {
      // console.log('embeddedAction', event)
      if (event.actionName === 'embedded_import_bom') {
        this.dialogImportTable = true
        return
      }
      if (event.actionName === 'embedded_import_pick_place') {
        this.dialogImportPickPlaceTable = true
        return
      }
    },
    onImportClose() {
      // console.log('onImportClose', event)
      this.dialogImportTable = false
    },
    importTable(selectedItems) {
      // console.log('importTable', selectedItems, editedItem)
      let data = {
        selected_items: selectedItems,
      }
      this.storeDetail.onAction({actionName: 'import_bom_sheet', actionUid: null, data: data})
      this.dialogImportTable = false
    },
    onImportPickPlaceClose() {
      // console.log('onImportClose', event)
      this.dialogImportPickPlaceTable = false
    },
    importPickPlaceTable(selectedItems) {
      // console.log('importPickPlaceTable', selectedItems, editedItem)
      let data = {
        selected_items: selectedItems,
      }
      this.storeDetail.onAction({actionName: 'import_pick_place', actionUid: null, data: data})
      this.dialogImportPickPlaceTable = false
    },
  }
  ,

  mounted() {
    this.storeDetail = useDetailStore(this.storeName)()
    this.storeAggregate = useAggregateStore()
  }
  ,

  data() {
    return {
      currentTab: 0,
      dialogImportTable: false,
      dialogImportPickPlaceTable: false,
      storeDetail: null,
      storeAggregate: null,
    }
  }
  ,
}
</script>

<style scoped>

</style>


<i18n src="@/components/CoreComponent/locales.json">
</i18n>